import React from 'react';
import "./announce.css"

export const Announce = () => {
  return (

    <>
    
   <div className="contain">

  
   <div class="container">
  

  <div class="event-card">
    <div class="left">
      <div class="date-time dt1">
        <p class="date">TODAY</p>
        <p class="time">17:00</p>
      </div>

      <div class="event-info">
        <h3 class="event-name">
          Lorem ipsum dolor, sit amet consectetur adipisicing.
        </h3>

        <p class="event-detail">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora saepe similique officia nam atque voluptatem ad necessitatibus consequuntur, nostrum repellendus.
        </p>
      </div>
    </div>

    <div class="right">
      <a href="/" class="add-to-calender">
        <ion-icon name="add-outline"></ion-icon> Add to calender
      </a>
    </div>
  </div>

  <div class="event-card">
    <div class="left">
      <div class="date-time dt2">
        <p class="date">22-31 OCT</p>
        <p class="time">10:00</p>
      </div>

      <div class="event-info">
        <h3 class="event-name">
          Lorem, ipsum.
        </h3>

        <p class="event-detail">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora saepe similique officia nam atque voluptatem ad necessitatibus consequuntur, nostrum repellendus.
        </p>
      </div>
    </div>

    <div class="right">
      <a href="/" class="add-to-calender">
        <ion-icon name="add-outline"></ion-icon> Add to calender
      </a>
    </div>
  </div>

  <div class="event-card">
    <div class="left">
      <div class="date-time dt3">
        <p class="date">22-31 OCT</p>
        <p class="time">19:00</p>
      </div>

      <div class="event-info">
        <h3 class="event-name">
          Lorem ipsum dolor sit amet consectetur.
        </h3>

        <p class="event-detail">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora saepe similique officia nam atque voluptatem ad necessitatibus consequuntur, nostrum repellendus.
        </p>
      </div>
    </div>

    <div class="right">
      <a href="/" class="add-to-calender">
        <ion-icon name="add-outline"></ion-icon> Add to calender
      </a>
    </div>
  </div>

  <div class="event-card">
    <div class="left">
      <div class="date-time dt4">
        <p class="date">13-31 DEC</p>
        <p class="time">10:00</p>
      </div>

      <div class="event-info">
        <h3 class="event-name">
          Lorem ipsum dolor sit.
        </h3>

        <p class="event-detail">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora saepe similique officia nam atque voluptatem ad necessitatibus consequuntur, nostrum repellendus.
        </p>
      </div>
    </div>

    <div class="right">
      <a href="/" class="add-to-calender">
        <ion-icon target="_blank" name="add-outline"></ion-icon> Add to calender
      </a>
    </div>
  </div>
</div>
    </div>
    </>
  )
}
